<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <order-search :params.sync="queryParams" :status-text="statusText" :order-count="orderCount" @filter="handleFilter" @import="handleImport" />
      </template>

      <order-table :list="list" is-local @verify="pickupVerify" />
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import OrderTable from '@/components/Order/order-table'
import OrderSearch from '@/components/Order/order-search'
import { getOrderList, getOrderCount } from '@/api/order'

export default {
  name: 'PremiumOrderList',
  components: {
    Pagination,
    OrderTable,
    OrderSearch
  },
  data() {
    return {
      list: null,
      total: 0,
      loading: false,
      queryParams: {
        keyword: '', // 关键词（用户昵称、手机号、分享码）
        dateRange: '', // 下单日期范围
        orderNumber: '',
        orderStatus: '0',
        orderType: 77000, // 本地商家订单
        payNumber: '',
        dateStart: '',
        dateEnd: '',
        shopName: '',
        consigneeInfo: '',
        page: 1,
        limit: 20
      },
      statusText: [
        { id: '0', text: '全部', field: 'all', value: 0 },
        { id: '5', text: '待核销', field: 'verified', value: 0 },
        { id: '4', text: '交易完成', field: 'completed', value: 0 }
      ],
      orderCount: {
        all: 0,
        verified: 0,
        completed: 0
      }
    }
  },
  created() {
    this.fetchAll()
  },
  methods: {
    fetchAll() {
      this.loading = true
      const promiseArray = [
        getOrderCount(this.queryParams),
        getOrderList(this.queryParams)
      ]
      Promise.all(promiseArray).then(([count, list]) => {
        this.orderCount = count
        this.list = list.records
        this.total = list.total
      }).finally(() => {
        this.$util.delay().then(() => { this.loading = false })
      })
    },
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.queryParams)
      if (params.dateStart) params.dateStart += ' 00:00:00'
      if (params.dateEnd) params.dateEnd += ' 23:59:59'
      const promiseArray = [getOrderCount(params), getOrderList(params)]
      Promise.all(promiseArray).then(([count, orders]) => {
        this.orderCount = count
        this.total = orders.total
        this.list = orders.records
      }).finally(() => {
        this.$util.delay().then(() => { this.loading = false })
      })
    },
    handleFilter(e) {
      this.loading = true
      this.queryParams.page = 1
      const params = Object.assign({}, this.queryParams)
      if (params.dateStart) params.dateStart += ' 00:00:00'
      if (params.dateEnd) params.dateEnd += ' 23:59:59'
      const promiseArray = [getOrderCount(params), getOrderList(params)]
      Promise.all(promiseArray).then(([count, orders]) => {
        this.orderCount = count
        this.total = orders.total
        this.list = orders.records
      }).finally(() => {
        this.$util.delay().then(() => { this.loading = false })
      })
    },
    handleImport() {
      this.handleFilter({ action: 'tab' })
    },
    pickupVerify() {
      this.queryParams.page = 1
      this.fetchData()
    }
  }
}
</script>
